import slice from "./siteConfigurationSlice";

export default slice.reducer;
